import { useEffect, useState } from "react";
import { _Inbox, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _CostStudy, _NationalizationProcessGeneralInfo, _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { MakeUBLInvoice } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/MakeUBLInvoice";
import { ThirdBankingAccountEditor } from "../../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectAdquisitionContract } from "../../../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/SelectAdquisitionContract";
import { SelectMonths } from "../../../../../contract/select/SelectMonths";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { PaymentMethodSelect } from "../../../../../Talentohumano/PaymentMethod/PaymentMethodSelect";
import { NationalizationProcessItemsBystudyCost } from "../NationalizationProcessItems/NationalizationProcessItemsBystudyCost";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { CurrencyEditor } from "../../../../../erp/cellEditor/Currency/CurrencyEditor";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const COST001 = ({ configProcedure }: Props) => {

    const costestudy = useDataBean(_NationalizationProcessGeneralInfo);

    const [invoice, setInvoice] = useState<any>({});
    const [props, setProps] = useState<any>({});
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalConfAdd, setModalConfAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [idflujo, setIDflujo] = useState<number>(0);


    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])
    useEffect(() => {
        console.log("cargando de props => ", props.IDNationalizationProcessGeneralInfo);

        if (props.IDNationalizationProcessGeneralInfo) {
            costestudy.instance.getNationalizationProcessGeneralInfoCatalogPorPropiedades({ IDNationalizationProcessGeneralInfo: props.IDNationalizationProcessGeneralInfo }, null).then(
                (resp: any) => {
                    if (resp.length > 0) {
                        console.log(resp[0].DataBeanProperties);
                        costestudy.setBean(resp[0].DataBeanProperties);
                    }

                }
            )
        }
        else{
            costestudy.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        }
    }, [props])

    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(costestudy.bean.ObservationsEC)
        }

        if (configProcedure?._pushProps) {
            let x = {
                IDNationalizationProcessGeneralInfo: costestudy.bean.IDNationalizationProcessGeneralInfo,
                State: 1
            }
            configProcedure?._pushProps(x)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(costestudy.bean)
        }
        toast.success('Actualizado')
    }


    const create = () => {
        costestudy.setBean({

            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID(),
            State: 1,

        });
        editaItem()
    }

    const createvdos = () => {
        costestudy.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        setTimeout(() => {
            editaItemvdos()            
        }, 4000);
    }

    const editaItem = () => {


        costestudy.instance.updateNationalizationProcessGeneralInfo(costestudy.bean).then(
            (resp: any) => {
                onExportMap()
                console.log(resp)
                toast.success('Actualizado');
            }
        ).catch(err => {
            toast.error(err);
        })
    }


    const editaItemvdos = () => {

        console.log(costestudy.bean);
        
        costestudy.instance.updateNationalizationProcessGeneralInfo(costestudy.bean).then(
            (resp: any) => {
                console.log(resp);
                toast.success('Actualizado');
                costestudy.setBean(resp);
                // configProcedure._pushProps({ IDNationalizationProcessGeneralInfo: resp.IDNationalizationProcessGeneralInfo });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    return (
        <div className="row">

            <div className="col-md-12">

                <strong>Estudio de Costos</strong>

                <div className="row">
                    {/* <PrintJson json={costestudy.bean} /> */}
                    <div className="col-md-12">

                        <SelectAdquisitionContract idSelector={costestudy.bean.IDAdquisitionContract} onChange={({ DataBeanProperties }) => { costestudy.setBean({ ...costestudy.bean, 'IDAdquisitionContract': DataBeanProperties.IDAdquisitionContract }) }} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="DateEC" label="Fecha del estudio de costos" value={costestudy.bean.DateEC} setDate={(e: any) => { costestudy.setBean({ ...costestudy.bean, "DateEC": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>No. Documento Transporte</label>
                        <input type="text" name="NoDocTransport" className="form-control" value={costestudy.bean.NoDocTransport} onChange={costestudy.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Medio o Formas de pago</label>
                        <PaymentMethodSelect idSelector={costestudy.bean.PaymentMethodEC} onChange={(e) => { costestudy.setBean({ ...costestudy.bean, "PaymentMethodEC": e }) }} />

                    </div>

                    <div className="col-md-6">
                        <label>Lugar de entrega de la mercancia</label>
                        <input type="text" name="DeliveryPlaceEC" className="form-control" value={costestudy.bean.DeliveryPlaceEC} onChange={costestudy.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Tasa de cambio para el estudio de costos</label>
                        <input type='text' name="ExchangeRate" className="form-control" value={costestudy.bean.ExchangeRate} onChange={costestudy.handleChange} />
                    </div>
                    {/* <div className="col-md-6">
                        <label>Tarifa</label>
                        <input type="text" name="TariffPositionEC" className="form-control" value={costestudy.bean.TariffPositionEC} onChange={costestudy.handleChange} />
                    </div> */}
                    <div className="col-md-6">
                        <label>Numero de meses que tendra de plazo para la entrega</label>
                        <input type="text" name="DeliveryDeadlineEC" className="form-control" value={costestudy.bean.DeliveryDeadlineEC} onChange={costestudy.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Mes de proyeccion de la entrega</label>
                        <SelectMonths idSelector={costestudy.bean.ProjectionMonthEC} onChange={(e: number) => { costestudy.setBean({ ...costestudy.bean, "ProjectionMonthEC": e }) }}></SelectMonths>
                    </div>
                    {/* <div className="col-md-6">

                        <label>Valor auto incremental</label>
                        <input type="text" name="NoCostStudyEC" className="form-control" value={costestudy.bean.NoCostStudyEC} onChange={costestudy.handleChange} />

                    </div> */}
                    <div className="col-md-6">

                        <label>Comision Forpo (%)</label>
                        <input type="text" name="ForpoComission" className="form-control" value={costestudy.bean.ForpoComission} onChange={costestudy.handleChange} />

                    </div>
                    <div className="col-md-6">

                        <label>Valor total del transporte</label>
                        <input type="text" name="TotalTransport" className="form-control" value={costestudy.bean.TotalTransport} onChange={costestudy.handleChange} />

                    </div>
                    <div className="col-md-6">
                        <CurrencyEditor id={costestudy.bean.CurrencyType} onchange={(e: any) => { costestudy.setBean({ ...costestudy.bean, "CurrencyType": e }) }}></CurrencyEditor>
                    </div>
                    <div className="col-md-6">

                        <label>Firma del estudio de costo</label>
                        <input type="text" name="FirmEC" className="form-control" value={costestudy.bean.FirmEC} onChange={costestudy.handleChange} />

                    </div>
                    <div className="col-md-12">
                        <label>Observaciones con respecto al estudio de costos</label>
                        <textarea name="ObservationsEC" className="form-control" value={costestudy.bean.ObservationsEC} onChange={(e) => { costestudy.setBean({ ...costestudy.bean, 'ObservationsEC': e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <AccountEditor idAccount={costestudy.bean.MadeByEC} label="USUARIO/PERSONAL que realiza el estudio de costos" onChange={(acc: any) => { costestudy.setBean({ ...costestudy.bean, "MadeByEC": acc.IDAccount }); }} />
                    </div>
                    <div className="col-md-6">
                        <AccountEditor idAccount={costestudy.bean.ReviewedByEC} label="USUARIO/PERONAL que hace la revisión del estudio de costos" onChange={(acc: any) => { costestudy.setBean({ ...costestudy.bean, "ReviewedByEC": acc.IDAccount }); }} />
                    </div>
                    <div className="col-md-12">
                        <label>Descripción de la mercancia</label>
                        <textarea name="MerchandiseDescriptionEC" className="form-control" value={costestudy.bean.MerchandiseDescriptionEC} onChange={(e) => { costestudy.setBean({ ...costestudy.bean, 'MerchandiseDescriptionEC': e.target.value }) }} />
                    </div>
                </div>
                <div className="row">

                    <div className="col-md-6">
                        <BasicButton icon="ri-install-fill" clase="primary" eventClick={editaItemvdos}>Guardar Datos*</BasicButton>
                    </div>
                </div>
                {costestudy.bean.IDNationalizationProcessGeneralInfo &&
                    <>
                        <div className="row">
                            {/* <PrintJson json={costestudy.bean} /> */}
                            <NationalizationProcessItemsBystudyCost IDNationalizationProcessGeneralInfo={costestudy.bean.IDNationalizationProcessGeneralInfo} />
                        </div>
                        <div className="row">
                            <div className="col-md-6">

                                <BasicButton icon="ri-inbox-unarchive-fill" clase="btn rounded-pill btn-warning waves-effect waves-light" eventClick={create}>Finalizar*</BasicButton>
                            </div>
                        </div>
                    </>
                }
            </div>
            {/* <div className="col-md-12">
                <PrintJson json={costestudy.bean} />
            </div> */}
        </div>
    )
}